/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewDomainsEmailRecord } from './CRSFSecReviewDomainsEmailRecord';
import {
    CRSFSecReviewDomainsEmailRecordFromJSON,
    CRSFSecReviewDomainsEmailRecordFromJSONTyped,
    CRSFSecReviewDomainsEmailRecordToJSON,
} from './CRSFSecReviewDomainsEmailRecord';

/**
 * 
 * @export
 * @interface CRSFSecReviewDomainsEmail
 */
export interface CRSFSecReviewDomainsEmail {
    /**
     * 
     * @type {CRSFSecReviewDomainsEmailRecord}
     * @memberof CRSFSecReviewDomainsEmail
     */
    dmarc: CRSFSecReviewDomainsEmailRecord;
    /**
     * 
     * @type {CRSFSecReviewDomainsEmailRecord}
     * @memberof CRSFSecReviewDomainsEmail
     */
    spf: CRSFSecReviewDomainsEmailRecord;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDomainsEmail
     */
    total: number;
    /**
     * 
     * @type {CRSFSecReviewDomainsEmailRecord}
     * @memberof CRSFSecReviewDomainsEmail
     */
    without_dmarc: CRSFSecReviewDomainsEmailRecord;
    /**
     * 
     * @type {CRSFSecReviewDomainsEmailRecord}
     * @memberof CRSFSecReviewDomainsEmail
     */
    without_spf: CRSFSecReviewDomainsEmailRecord;
}

/**
 * Check if a given object implements the CRSFSecReviewDomainsEmail interface.
 */
export function instanceOfCRSFSecReviewDomainsEmail(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "dmarc" in value;
    isInstance = isInstance && "spf" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "without_dmarc" in value;
    isInstance = isInstance && "without_spf" in value;

    return isInstance;
}

export function CRSFSecReviewDomainsEmailFromJSON(json: any): CRSFSecReviewDomainsEmail {
    return CRSFSecReviewDomainsEmailFromJSONTyped(json, false);
}

export function CRSFSecReviewDomainsEmailFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewDomainsEmail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dmarc': CRSFSecReviewDomainsEmailRecordFromJSON(json['dmarc']),
        'spf': CRSFSecReviewDomainsEmailRecordFromJSON(json['spf']),
        'total': json['total'],
        'without_dmarc': CRSFSecReviewDomainsEmailRecordFromJSON(json['without_dmarc']),
        'without_spf': CRSFSecReviewDomainsEmailRecordFromJSON(json['without_spf']),
    };
}

export function CRSFSecReviewDomainsEmailToJSON(value?: CRSFSecReviewDomainsEmail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dmarc': CRSFSecReviewDomainsEmailRecordToJSON(value.dmarc),
        'spf': CRSFSecReviewDomainsEmailRecordToJSON(value.spf),
        'total': value.total,
        'without_dmarc': CRSFSecReviewDomainsEmailRecordToJSON(value.without_dmarc),
        'without_spf': CRSFSecReviewDomainsEmailRecordToJSON(value.without_spf),
    };
}

